import Vue from 'vue'
import { Message } from 'element-ui'

// Default custom class mapping based on notification type
const defaultCustomClassMap = {
    success: 'notification-unlock',
    warning: 'notification-lock',
    error: 'notification-lock',
    info: ''
}

// Trạng thái reactive để component có thể disable nút khi đang hiển thị thông báo
export const notificationState = Vue.observable({ isShowing: false })

// Chỉ 1 thông báo tại một thời điểm; khi đang hiển thị thì bỏ qua lần gọi mới (tránh spam nhiều thông báo)
let currentMessageInstance = null

function showInternal(instance, type, message, options) {
    // Xóa hết message cũ để message mới luôn xuất hiện cùng một vị trí (tránh lần 1 cao, từ lần 2 lệch xuống)
    try {
        Message.closeAll()
    } catch (e) {
        // ignore
    }

    const customClass = options.customClass !== undefined
        ? options.customClass
        : defaultCustomClassMap[type] || ''

    const opts = {
        showClose: true,
        message,
        type,
        duration: options.duration || 3000,
        offset: options.offset || 20,
        customClass,
        ...options,
        onClose: () => {
            currentMessageInstance = null
            notificationState.isShowing = false
            if (options.onClose) options.onClose()
        }
    }
    const msg = instance.$message(opts)
    if (msg && typeof msg.close === 'function') {
        currentMessageInstance = msg
    }
}

export function isNotificationShowing() {
    return notificationState.isShowing
}

export function showNotication(instance, type, message, options = {}) {
    // Trong lúc đang hiển thị thông báo thì bỏ qua lần gọi mới → không gọi API / không xử lý thêm từ button
    if (notificationState.isShowing) {
        return
    }

    notificationState.isShowing = true
    showInternal(instance, type, message, options)
}

export function showColoredNotification(instance, type, message, options = {}) {
    return showNotication(instance, type, message, options)
}


